const REG_EXP_ASCII_ONE_CHAR = /[ -~]/g
const REG_EXP_ASCII_ONLY = /^[ -~]+$/

const REG_EXP_ALPHABET_ONLY = /^[ A-Za-z]+$/
const REG_EXP_ALPHABET_ONE_CHAR = /[ A-Za-z]/g

const REG_EXP_NUMBER_ONLY = /^[0-9]+$/
export const REG_EXP_NUMBER_ONE_CHAR = /[0-9]/g

const REG_EXP_ALPHABET_UNDERSCORE_ONLY = /^[ 0-9a-z_]+$/
const REG_EXP_ALPHABET_UNDERSCORE_ONE_CHAR = /[ 0-9a-z_]/g

export function excludeNonAsciiChar(value, prevValue) {
  const valueNoSmartPunctuation = revertSmartPunctuation(value, prevValue)
  if (
    !!valueNoSmartPunctuation &&
    !REG_EXP_ASCII_ONLY.test(valueNoSmartPunctuation)
  ) {
    const filteredValue = (
      valueNoSmartPunctuation.match(REG_EXP_ASCII_ONE_CHAR) || []
    ).join('')
    return filteredValue
  }
  return valueNoSmartPunctuation
}

export function excludeNonAlphabet(value) {
  if (!!value && !REG_EXP_ALPHABET_ONLY.test(value)) {
    return (value.match(REG_EXP_ALPHABET_ONE_CHAR) || []).join('')
  }
  return value
}

export function excludeNonNumber(value) {
  if (!!value && !REG_EXP_NUMBER_ONLY.test(value)) {
    return (value.match(REG_EXP_NUMBER_ONE_CHAR) || []).join('')
  }
  return value
}

// iOS 11以降で行われているSmart Punctuationにより
// 自動入力された非ASCII文字をASCII文字に戻す。
// https://pspdfkit.com/blog/2018/ios-11-smart-punctuation/
function revertSmartPunctuation(value, prevValue) {
  let returnVal = value

  if (returnVal.includes(`‘`) || returnVal.includes(`’`)) {
    returnVal = returnVal.replace(/[‘’]/g, `'`)
  }

  if (returnVal.includes(`“`) || returnVal.includes(`”`)) {
    returnVal = returnVal.replace(/[“”]/g, `"`)
  }

  if (returnVal.includes('—') /* emdash */) {
    if (value.length === prevValue.length - 1) {
      // '--'の次に'-'を入力し、1つのemdashとなる場合。
      // prevValに非ASCII文字は含まれていないはずなので、1文字削除の際はここを通らない。
      returnVal = returnVal.replace(/—/, '---')
    } else {
      returnVal = returnVal.replace(/—/g, '--')
    }
  }

  return returnVal
}

export function excludeOnlyLowercaseAlphabetAndUnderscore(value) {
  if (!!value && !REG_EXP_ALPHABET_UNDERSCORE_ONLY.test(value)) {
    return (value.match(REG_EXP_ALPHABET_UNDERSCORE_ONE_CHAR) || []).join('')
  }
  return value
}
